import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { ConfigurationProvider } from './context/ConfigurationContext';
import { DashboardProvider } from './context/DashboardContext';
import Dashboard from './components/Dashboard';

function App() {
  return (
    <AuthProvider>
      <ConfigurationProvider>
        <DashboardProvider>
          <Dashboard />
        </DashboardProvider>
      </ConfigurationProvider>
    </AuthProvider>
  );
}

export default App;
